import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TeamInfoRouting} from '@modules/team/modules/team-info/team-info.routing';
import {TeamInfoComponent} from '@modules/team/modules/team-info/team-info.component';
import {TeamInfoContactComponent} from '@modules/team/modules/team-info/pages/contact/team-info-contact.component';
import {TeamInfoFunctionariesComponent} from '@modules/team/modules/team-info/pages/functionaries/team-info-functionaries.component';
import {TeamInfoSponsorsComponent} from '@modules/team/modules/team-info/pages/sponsors/team-info-sponsors.component';
import {TeamInfoStadionComponent} from '@modules/team/modules/team-info/pages/stadion/team-info-stadion.component';
import {SharedModule} from '@shared/shared.module';
import {SharedBannersModule} from '@shared/modules/shared-banners/shared-banners.module';

@NgModule({
  declarations: [
    TeamInfoComponent,
    TeamInfoContactComponent,
    TeamInfoFunctionariesComponent,
    TeamInfoSponsorsComponent,
    TeamInfoStadionComponent,
  ],
    imports: [
        CommonModule,
        TeamInfoRouting,
        SharedModule,
        SharedBannersModule
    ],
})
export class TeamInfoModule { }
